import React from "react";
import MediaQuery from "react-responsive";
import group1 from "../assets/grupo-1.png";
import group2 from "../assets/grupo-2.png";

import group1M from "../assets/group-1-mobile.png";
import group2M from "../assets/group-2-mobile.png";

const getStyleGroup1 = (mediaQuery) => {
  return Object.assign({}, group1Style["default"], group1Style[mediaQuery]);
};

const getStyleGroup1M = (mediaQuery) => {
  return Object.assign({}, group1Style["default"], group1Style[mediaQuery]);
}



const AboutUs = () => {
  return (
    <div style={container}>
      <div style={{ marginBottom: "80px" }}>
        <span>
          <b>LIFE AT ANTHOR</b>
        </span>
      </div>
      <br />
      <div style={{ maxWidth: "700px" }}>
        <h3 style={{ color: "#1578D7" }}>
          We’re a team of passionate people, we love what we do and have an urge
          to keep growing at all costs.
        </h3>
      </div>
      <div style={{ maxWidth: "700px" }}>
        <label style={{ color: "#797979" }}>
          Our day to day life includes: solving problems, having great ideas,
          talking with customers, building new features (and correcting old
          bugs) and drinking lots of specialty coffee.
        </label>
      </div>
      <br />

      <MediaQuery minDeviceWidth={1000}>
        <div style={getStyleGroup1()}>
          <img src={group1} alt="equip" />
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={999}>
        <div style={getStyleGroup1M()}>
          <img src={group1M} alt="equip" style={{ width: "100%"}} />
        </div>
      </MediaQuery>
      <div style={{ maxWidth: "700px", marginTop: "50px" }}>
        <label style={{ color: "#797979" }}>
          That’s us celebrating when we hit our goal of 1000 activities! We had
          some champagne, snacks and cake. Also, that’s what the product team
          room looked like at the time.
        </label>
      </div>
      <MediaQuery minDeviceWidth={1000}>
        <div style={getStyleGroup1()}>
          <img src={group2} alt="equip" />
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={999}>
        <div style={getStyleGroup1M()}>
          <img src={group2M} alt="equip" style={{ width: "100%"}} />
        </div>
      </MediaQuery>
      <div style={{ maxWidth: "700px", marginTop: "50px" }}>
        <label style={{ color: "#797979" }}>
          We’re very united and energetic. We get together every month to play
          board games, every friday we have a stand up meeting with beer and
          snacks, and we always try to lunch together.
        </label>
      </div>
    </div>
  );
};

const container = {
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  alignItems: "center"
};
const group1Style = {
  default: {
    marginTop: "50px"
  },
  "1000": {
    display: "none"
  }
};
export default AboutUs;
